import React from "react";
import "./navapark.scss";
import data from "../../data.json";
import Heroc from "../../../component/hero/heroc.jsx";
import Aboutc from "../../../component/about/aboutc.jsx";
import Heroimages from "../../../asset/hero/heroimages.js";
import Promoc from "../../../component/promo/promoc.jsx";
import hsimages from "../../../asset/hardsell/hsimages.js";
import prmo from "../../../component/promo/promocard.json";
import Carouselfasc from "../../../component/carouselfas/carouselfasc.jsx";
import fas from "../../../component/carouselfas/carouselfasc.json";
import fasnavapark from "../../../asset/fascarousel/fas-navapark/fas-navapark.js";
import dataproduk from "../../../component/cardprodukdetail/cardprodukdetail.json";
import imgLaurel10 from "../../../asset/imgrumah/img-navapark/img-laurel/img-laurelt10/laurelt10.js";
import imgLaurel12 from "../../../asset/imgrumah/img-navapark/img-laurel/img-laurelt12/laurelt12.js";
import imgLayton12 from "../../../asset/imgrumah/img-navapark/img-layton/img-laytont12/t12.js";
import imgLayton15 from "../../../asset/imgrumah/img-navapark/img-layton/img-laytont15/t15.js";
import imgLyndon12 from "../../../asset/imgrumah/img-navapark/img-lyndon/img-lyndont12/lyndont12.js";
import imgLyndon15 from "../../../asset/imgrumah/img-navapark/img-lyndon/img-lyndont15/lyndont15.js";
import imgLyndon19 from "../../../asset/imgrumah/img-navapark/img-lyndon/img-lyndont19/lyndont19.js";
import Cardprodukdetail from "../../../component/cardprodukdetail/cardprodukdetail.jsx";
import ScrollToHashElement from "../../home/ScrollToHashElement.js";
const imgMap = {
  fasnavapark,
};
const imageMap = {
  imgLaurel10,
  imgLaurel12,
  imgLayton12,
  imgLayton15,
  imgLyndon12,
  imgLyndon15,
  imgLyndon19,
};

const navapark = () => {
  return (
    <div className="navapark">
      <ScrollToHashElement />
      <div className="hero">
        {data.navaparkab.map((hero, index) => {
          // Determine the logo dynamically
          const fotopromo = Heroimages[hero.imagehero];
          return (
            <Heroc
              key={index}
              imagehero={fotopromo} // Dynamically import logo images // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="about">
        {data.navaparkab.map((home, index) => {
          // Determine the logo dynamically
          return (
            <Aboutc
              key={index}
              judul={home.judul}
              subjudul={home.subjudul} // Dynamically import logo images // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="container-promo">
        {prmo.Navapark.map((promo, index) => {
          // Determine the logo dynamically
          const fotopromo = hsimages[promo.imagehs];
          return (
            <Promoc
              key={index}
              imagehs={fotopromo} // Dynamically import logo images
              titlepromo={promo.titlepromo}
              details={promo.details}
              whatsappLink={promo.whatsappLink}
              quote={promo.quote} // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="carouselfas">
        {fas.fasNavapark.map((slide, index) => {
          return <Carouselfasc key={index} carousel={imgMap[slide.carousel]} />;
        })}
      </div>
      <div id="laurel" className="devider">
        <div className="a">LAUREL</div>
      </div>
      <div className="produkcontainer">
        {dataproduk.Laurelp.map((card, index) => {
          return (
            <Cardprodukdetail
              key={index}
              src={imageMap[card.imagesKey]}
              title={card.title}
              sub={card.sub}
              subt={card.subt}
              details={card.details}
              price={card.price}
              whatsappLink={card.whatsappLink}
            />
          );
        })}
      </div>
      <div id="lyndon" className="devider">
        <div className="a">LYNDON</div>
      </div>
      <div className="produkcontainer">
        {dataproduk.Lyndonp.map((card, index) => {
          return (
            <Cardprodukdetail
              key={index}
              src={imageMap[card.imagesKey]}
              title={card.title}
              sub={card.sub}
              subt={card.subt}
              details={card.details}
              price={card.price}
              whatsappLink={card.whatsappLink}
            />
          );
        })}
      </div>
      <div id="layton" className="devider">
        <div className="a">LAYTON</div>
      </div>
      <div className="produkcontainer">
        {dataproduk.Laytonp.map((card, index) => {
          return (
            <Cardprodukdetail
              key={index}
              src={imageMap[card.imagesKey]}
              title={card.title}
              sub={card.sub}
              subt={card.subt}
              details={card.details}
              price={card.price}
              whatsappLink={card.whatsappLink}
            />
          );
        })}
      </div>
    </div>
  );
};

export default navapark;
